import { useQuery } from '@tanstack/react-query';

import { workspacesQueryOptions } from '@/lib/api/workspaces.js';

import {
  resolveWorkspaceSharing,
  type WorkspaceSharing,
} from './workspace-access.js';

/**
 * Whether a workspace is the caller's personal one, for a surface that holds the id but not the row.
 *
 * It reads the caller's own workspace directory — the list the switcher already keeps in the query
 * cache, so this costs no extra request in practice — and answers `'unknown'` until the row is there or
 * when the id is not in it. Every caller has to handle that third value: the answer arrives after the
 * first render, and a default of `'personal'` or `'shared'` would silently pick a side.
 */
export function useWorkspaceSharing(
  workspaceId: string | null,
): WorkspaceSharing {
  const { data: workspaces } = useQuery(workspacesQueryOptions());
  if (workspaceId === null) return 'unknown';
  return resolveWorkspaceSharing(
    workspaces?.find((workspace) => workspace.id === workspaceId),
  );
}
